import { takeLatest, put, select, call } from 'redux-saga/effects';
import { createAxios, logNative } from '../utils/utils';
import {
  WP_CATEGORY_LABELS_65,
  WP_CATEGORY_TAGIMG_65,
  WP_CATEGORY_LABELS_60,
  WP_CATEGORY_TAGIMG_60,
  WP_RECOMMEND_IMG_60,
  WP_TOP_BANNER_60,
  // WP_MINE_COLLECTIMG_60,
  // WP_MINE_SETUP_60,
  WP_MINE_COLLECTIMG_80,
  WP_MINE_SETUP_80,
  WP_MINE_PAY_LIST_80,
  WP_REPROT_OPT_80,
  WP_SCREEN_LIST_60,
  WP_AUTHOR_LIST_64,
  WP_AUTHOR_DETAIL_64,
  WP_AUTHOR_SHOWREEL_64,
  WP_DETAIL_RECO_65,
  WP_RECO_BANNER_65,
  WP_RECO_GROUP_65,
  WP_RANK_MORE_65,
  WP_PAY_RANK_LIST_80,
  WP_BATCH_SHOW_87,
} from '../config/index';

import {
  // 壁纸分类
  GET_WP_CATEGORY_LABELS,
  GET_WP_CATEGORY_IMGINFO,
  SET_WP_CATEGORY_IMGINFO,
  SET_WP_CATEGORY_LABELS,
  // 壁纸精选
  GET_WP_BANNER_LIST,
  GET_WP_RECOMMEND_LIST,
  SET_WP_BANNER_LIST,
  SET_WP_RECOMMEND_LIST,
  SET_WP_DETAIL_RECO_BANNER,
  GET_WP_DETAIL_RECO_BANNER,
  GET_WP_RECO_BANNER,
  SET_WP_RECO_BANNER,
  GET_WP_RECO_GROUP,
  SET_WP_RECO_GROUP,
  GET_WP_RANK_MORE,
  SET_WP_RANK_MORE,
  // 壁纸我的
  GET_WP_COLLECT_LIST,
  GET_WP_SETUP_LIST,
  GET_WP_MINE_PAY_LIST,
  SET_WP_MINE_LIST,
  GET_WP_OPTERAYTION,
  SET_WP_OPTERAYTION,
  // 锁屏壁纸
  GET_WP_SCREEN_LIST,
  SET_WP_SCREEN_LIST,
  // 壁纸 作家列表
  GET_WP_AUTHOR_LIST,
  SET_WP_AUTHOR_LIST,
  // 壁纸 作家详情
  GET_WP_AUTHOR_DETAIL,
  // 壁纸 作家集
  SET_WP_AUTHOR_SHOWREEL,
  GET_WP_AUTHOR_SHOWREEL,
  WP_BATCH_SHOW,
  SET_WP_BATCH_SHOW,
} from '../constants/wallpaper';

/**
 * 壁纸详情页面随便看看
 */
function* fetchWPDetailBanner(param) {
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_DETAIL_RECO_65, {
      params: { pageType: param.pageType || 'wallpaperDetail' },
    });
    if (res.data.status === 0) {
      // 添加到下载
      yield put({
        type: SET_WP_DETAIL_RECO_BANNER,
        payload: { ...res.data.data },
      });
    }
  } catch (error) {
    logNative(`获取壁纸推荐页banner 错误${error}`, error);
  }
}

/**
 * 壁纸榜单专题页面
 */
function* fetchWPRankList(param) {
  const rankListOld = yield select(state => state.wallpaper.rankList);
  const axios = yield createAxios();

  yield put({
    type: SET_WP_RANK_MORE,
    payload: {
      ...rankListOld,
      load: true,
    },
  });
  try {
    let url = param && param.pay === '1' ? WP_PAY_RANK_LIST_80 : WP_RANK_MORE_65;
    const res = yield axios.get(url, {
      params: {
        limit: param.limit,
        skip: param.skip,
        code: param.code || '1',
        wallpaperId: param.wallpaperId,
      },
    });
    if (res.data && res.data.data && res.data.status === 0 && res.data.data.wallpapers) {
      const newList = param.refresh
        ? res.data.data.wallpapers
        : [...rankListOld.list, ...res.data.data.wallpapers];
      yield put({
        type: SET_WP_RANK_MORE,
        payload: {
          list: newList,
          code: param.code || '',
          wallpaperId: param.wallpaperId,
          ...res?.data?.data,
          pagenation: {
            skip: newList.length,
            limit: rankListOld.pagenation.limit,
            count: res.data.data.count || 0,
          },
          load: false,
        },
      });
    }
  } catch (error) {
    logNative(`获取壁纸榜单专题页面 错误${error}`, error);
  }
}
/**
 * 壁纸推荐页banner new
 */
function* fetchWPRecoBanner(param) {
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_RECO_BANNER_65, {
      params: { pageType: param.pageType || 'wallpaper' },
    });
    if (res.data.status === 0) {
      // 添加到下载
      yield put({
        type: SET_WP_RECO_BANNER,
        payload: { ...res.data.data },
      });
    }
    if (res.data.status === -1) {
      yield put({
        type: SET_WP_RECO_BANNER,
        payload: {},
      });
    }
  } catch (error) {
    yield put({
      type: SET_WP_RECO_BANNER,
      payload: {},
    });
    logNative(`获取壁纸推荐页banner 错误${error}`, error);
  }
}

/**
 * 壁纸推荐页group
 */
function* fetchWPRecoGroup(param) {
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_RECO_GROUP_65, {
      params: { pageType: param.pageType || 'wallpaper' },
    });
    if (res.data.status === 0) {
      // 添加到下载
      yield put({
        type: SET_WP_RECO_GROUP,
        payload: res.data.data,
      });
    }
    if (res.data.status === -1) {
      yield put({
        type: SET_WP_RECO_GROUP,
        payload: [],
      });
    }
  } catch (error) {
    yield put({
      type: SET_WP_RECO_GROUP,
      payload: [],
    });
    logNative(`获取壁纸推荐页group 错误${error}`, error);
  }
}

/**
 * 壁纸推荐页, 壁纸list
 */
function* fetchRecommendList(datas) {
  const recommends = yield select(state => state.wallpaper.recommendInfo);
  yield put({
    type: SET_WP_RECOMMEND_LIST,
    payload: { load: true },
  });
  if (datas.payload.refresh) {
    yield put({
      type: SET_WP_RECOMMEND_LIST,
      payload: {
        list: [],
        pagenation: {
          ...datas.payload,
          skip: 0,
          count: 0,
        },
      },
    });
  }
  const axios = yield createAxios();

  try {
    const res = yield axios.get(WP_RECOMMEND_IMG_60, {
      params: datas.payload,
    });
    if (res.data.status === 0) {
      const { data } = res;
      const newList = datas.payload.refresh
        ? data.data.wallpapers
        : [...recommends.list, ...data.data.wallpapers];
      yield put({
        type: SET_WP_RECOMMEND_LIST,
        payload: {
          list: newList,
          name: data.data.name,
          pagenation: {
            ...datas.payload,
            skip: newList.length,
            count: data.data.count ? +data.data.count : 0,
          },
        },
      });
    }
  } catch (error) {
    logNative(`获取壁纸推荐页, 壁纸list fetchBannerList 错误${error}`, error);
  } finally {
    yield put({
      type: SET_WP_RECOMMEND_LIST,
      payload: {
        load: false,
      },
    });
  }
}

/**
 * 壁纸推荐页banner
 */
function* fetchBannerList() {
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_TOP_BANNER_60, {
      params: {},
    });
    if (res.data.status === 0) {
      // 添加到下载
      yield put({
        type: SET_WP_BANNER_LIST,
        payload: res.data.data,
      });
    }
  } catch (error) {
    logNative(`获取壁纸推荐页banner 错误${error}`, error);
  }
}

/**
 * 壁纸分类标签
 */
function* fetchLabelList() {
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_CATEGORY_LABELS_65);
    if (res.data.status === 0) {
      // 添加到下载
      yield put({
        type: SET_WP_CATEGORY_LABELS,
        payload: res.data.data,
      });
    }
  } catch (error) {
    logNative(`获取壁纸分类标签 fetchLabelList 错误${error}`, error);
  }
}

/**
 * 壁纸分类页面, 壁纸list
 */
function* fetchImgList(params) {
  const info = yield select(state => state.wallpaper.categoryInfo);
  const { list } = info;
  yield put({
    type: SET_WP_CATEGORY_IMGINFO,
    payload: {
      load: true,
    },
  });
  if (params.payload.refresh) {
    yield put({
      type: SET_WP_CATEGORY_IMGINFO,
      payload: {
        list: [],
        pagenation: {
          ...params.payload,
          skip: 0,
          count: 0,
        },
      },
    });
  }
  const axios = yield createAxios();

  try {
    const res = yield axios.get(WP_CATEGORY_TAGIMG_65, {
      params: params.payload,
    });
    if (res.data.status === 0) {
      const newList = !params.payload.refresh
        ? [...list, ...res.data.data.wallpapers]
        : res.data.data.wallpapers;
      yield put({
        type: SET_WP_CATEGORY_IMGINFO,
        payload: {
          list: newList,
          pagenation: {
            ...params.payload,
            skip: newList.length,
            count: res.data.data.count ? +res.data.data.count : 0,
          },
        },
      });
    } else if (res.data.status !== 0 && params.payload.refresh) {
      yield put({
        type: SET_WP_CATEGORY_IMGINFO,
        payload: {
          list: (res.data.data && res.data.data.wallpapers) || [],
          pagenation: {
            ...params.payload,
            skip: 0,
            count: 0,
          },
        },
      });
    }
  } catch (error) {
    logNative(`获取壁纸分类页面, 壁纸list fetchImgList 错误${error}`, error);
  } finally {
    yield put({
      type: SET_WP_CATEGORY_IMGINFO,
      payload: {
        load: false,
      },
    });
  }
}

/**
 * type类型：
 * 1-收藏 （点赞）
 * 2-收藏列表中删除（即取消点赞）
 * 3-设为壁纸
 * 4-从曾用壁纸中删除
 * @param {*} param0
 */
function* fetchWpOption({ param }) {
  yield put({
    type: SET_WP_OPTERAYTION,
    payload: {
      load: true,
    },
  });
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.get(WP_REPROT_OPT_80, {
      params: param,
    });
    if (res.data) {
      yield put({
        type: SET_WP_OPTERAYTION,
        payload: {
          ...res.data,
          ...param,
          load: false,
        },
      });
    }
  } catch (error) {
    yield put({
      type: SET_WP_OPTERAYTION,
      payload: {
        ...param,
        status: 1,
        load: false,
      },
    });
    logNative(`壁纸操作 fetchWpOption 错误${error}`, error);
  }
}

/**
 * 获取锁屏壁纸list
 * @param {*} param0
 */
function* fetchWpScreenList({ param }) {
  yield put({
    type: SET_WP_SCREEN_LIST,
    payload: {
      load: true,
    },
  });
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_SCREEN_LIST_60, {
      params: param,
    });
    if (res.data.status === 0) {
      yield put({
        type: SET_WP_SCREEN_LIST,
        payload: {
          ...res.data.data,
          ...param,
          load: false,
        },
      });
    } else {
      yield put({
        type: SET_WP_SCREEN_LIST,
        payload: {
          ...res.data,
          ...param,
          load: false,
        },
      });
      logNative(
        `获取锁屏壁纸list fetchWpScreenList 错误${JSON.stringify({
          ...res.data,
          ...param,
          load: false,
        })}, 即将跳入壁纸首页。`,
        {},
      );
    }
  } catch (error) {
    logNative(`获取锁屏壁纸list fetchWpScreenList 错误${error}`, error);
  }
}

/**
 *
 * @param {*} param0 分页参数
 * 获取壁纸 全部作者
 */
function* fetchWPAuthorList({ payload }) {
  const info = yield select(state => state.wallpaper.wpAuthorList);
  yield put({
    type: SET_WP_AUTHOR_LIST,
    payload: {
      load: true,
    },
  });
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_AUTHOR_LIST_64, {
      params: payload,
    });
    if (res.data.status === 0) {
      let authorlist = !payload.refresh ? info.list : [];
      if (res.data.data && res.data.data.authorList) {
        authorlist = [...authorlist, ...res.data.data.authorList];
      }
      yield put({
        type: SET_WP_AUTHOR_LIST,
        payload: {
          list: authorlist,
          pagenation: {
            ...payload,
            skip: authorlist.length - 1 || 0,
            count: res.data.data && res.data.data.count,
          },
          load: false,
        },
      });
    } else {
      yield put({
        type: SET_WP_AUTHOR_LIST,
        payload: {
          list: !payload.refresh ? info.list : [],
          pagenation: payload,
          load: false,
        },
      });
      logNative(
        `获取壁纸作家list fetchWPAuthorList 错误${{
          ...payload,
          ...res.data,
        }}`,
        res.data,
      );
    }
  } catch (error) {
    const { list } = info;
    yield put({
      type: SET_WP_AUTHOR_LIST,
      payload: {
        list,
        pagenation: {
          ...info.pagenation,
          count: 0,
          skip: list.length,
        },
        load: false,
      },
    });
    logNative(`获取壁纸作家list fetchWPAuthorList 错误${error}`, error);
  }
}

/**
 *
 * @param {*} param0 作家id
 * 获取作家详情
 */
function* fetchWPAuthorDetail({ payload }) {
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_AUTHOR_DETAIL_64, {
      params: payload.params,
    });
    if (res.data.status === 0) {
      payload.callback(res.data.data);
    }
    if (res.data.status !== 0) {
      logNative(
        `获取壁纸作家详情 fetchWPAuthorDetail 错误${{
          ...res.data,
          ...payload.params,
          load: false,
        }}`,
        {},
      );
    }
  } catch (error) {
    logNative(`获取壁纸作家list fetchWPAuthorDetail 错误${error}`, error);
  }
}
/**
 *
 * @param {*} param0
 */
function* fetchWPAuthorShowreel({ payload }) {
  const info = yield select(state => state.wallpaper.wpAuthorShowreel);
  yield put({
    type: SET_WP_AUTHOR_SHOWREEL,
    payload: {
      load: true,
    },
  });
  const axios = yield createAxios();
  try {
    const res = yield axios.get(WP_AUTHOR_SHOWREEL_64, {
      params: payload,
    });
    if (res.data.status === 0) {
      const {
        data: {
          data: { wallpapers, count },
        },
      } = res;
      let list = [];
      if (payload.refresh) {
        list = wallpapers;
      } else {
        list = [...info.list, ...wallpapers];
      }
      yield put({
        type: SET_WP_AUTHOR_SHOWREEL,
        payload: {
          list,
          pagenation: {
            ...info.pagenation,
            count,
            skip: list.length,
            authorId: payload.authorId,
          },
          load: false,
        },
      });
    } else {
      const list = payload.refresh ? [] : info.list;
      yield put({
        type: SET_WP_AUTHOR_SHOWREEL,
        payload: {
          list,
          pagenation: {
            ...info.pagenation,
            authorId: payload.authorId,
            count: 0,
            skip: list.length,
          },
          load: false,
        },
      });
    }
    if (res.data.status !== 0) {
      logNative(
        `获取壁纸作家作品 fetchWPAuthorShowreel 错误${JSON.stringify({
          ...res.data,
          ...payload,
          load: false,
        })}`,
        {},
      );
    }
  } catch (error) {
    const { list } = info;
    yield put({
      type: SET_WP_AUTHOR_SHOWREEL,
      payload: {
        list,
        pagenation: {
          ...info.pagenation,
          count: 0,
          skip: list.length,
        },
        load: false,
      },
    });
    logNative(`获取壁纸作家作品 fetchWPAuthorShowreel 错误${error}`, error);
  }
}

function* fetchBatchShow({ payload }) {
  const axios = yield createAxios('isNeedUser');
  try {
    const res = yield axios.post(WP_BATCH_SHOW_87, { ...payload });
    if (res.data.status === 0) {
      yield put({
        type: SET_WP_BATCH_SHOW,
        hasCarousel: res.data.data?.hasCarousel,
        isShow: payload.isShow,
        groupType: payload.groupType,
        classifyId: payload.classifyId,
        tagId: payload.tagId,
      });
    } else if (res.data.status === 2) {
      yield put({
        type: SET_WP_BATCH_SHOW,
        hasCarousel: 0,
        isShow: payload.isShow,
        groupType: payload.groupType,
        classifyId: payload.classifyId,
        tagId: payload.tagId,
      });
    }
  } catch (err) {
    yield put({
      type: SET_WP_BATCH_SHOW,
      hasCarousel: 0,
      isShow: payload.isShow,
      groupType: null,
      classifyId: null,
      tagId: null,
    });
    logNative(`获取是否展示批量添加失败 fetchBatchShow 错误${err}`, err);
  }
}

// rank页面
export function* watchFetchWPRankList() {
  yield takeLatest(GET_WP_RANK_MORE, fetchWPRankList);
}
// 推荐
export function* watchFetchWPDetailBanner() {
  yield takeLatest(GET_WP_DETAIL_RECO_BANNER, fetchWPDetailBanner);
}
export function* watchFetchWPRecoBanner() {
  yield takeLatest(GET_WP_RECO_BANNER, fetchWPRecoBanner);
}
export function* watchFetchWPRecoGroup() {
  yield takeLatest(GET_WP_RECO_GROUP, fetchWPRecoGroup);
}
export function* watchFetchWPBannerList() {
  yield takeLatest(GET_WP_BANNER_LIST, fetchBannerList);
}
export function* watchFetchWPRecommendList() {
  yield takeLatest(GET_WP_RECOMMEND_LIST, fetchRecommendList);
}
// 分类
export function* watchFetchWPCategoryLabels() {
  yield takeLatest(GET_WP_CATEGORY_LABELS, fetchLabelList);
}
export function* watchFetchWPCategoryImgList() {
  yield takeLatest(GET_WP_CATEGORY_IMGINFO, fetchImgList);
}

// 壁纸操作
export function* watchFetchWpOption() {
  yield takeLatest(GET_WP_OPTERAYTION, fetchWpOption);
}
// 锁屏壁纸
export function* watchFetchWpScreenListn() {
  yield takeLatest(GET_WP_SCREEN_LIST, fetchWpScreenList);
}
// 作者详情页面
export function* watchFetchWPAuthorList() {
  yield takeLatest(GET_WP_AUTHOR_LIST, fetchWPAuthorList);
}
export function* watchFetchWPAuthorDetail() {
  yield takeLatest(GET_WP_AUTHOR_DETAIL, fetchWPAuthorDetail);
}
export function* watchFetchWPAuthorShowreel() {
  yield takeLatest(GET_WP_AUTHOR_SHOWREEL, fetchWPAuthorShowreel);
}

// 批量添加轮播按钮的显示
export function* watchFetchBatchShow() {
  yield takeLatest(WP_BATCH_SHOW, fetchBatchShow);
}
